import React from "react";
import GreBannerImage from "component/common/GreBannerImage";
import { isValidMongoObjectId, normalizeMongoId } from "utils/utils";

// GRE visitor form header: per-property banner when propertyId is set, else legacy imageSrc.
const PropertyDeveloperBanner = ({
  propertyTitle,
  propertyId,
  imageSrc,
  className = "",
}) => {
  const normalizedPropertyId = normalizeMongoId(propertyId);

  if (isValidMongoObjectId(normalizedPropertyId)) {
    return (
      <GreBannerImage
        propertyId={normalizedPropertyId}
        propertyTitle={propertyTitle}
        className={className}
        withShell
        imageClassName="gre-banner-shell__image"
      />
    );
  }

  if (!imageSrc) {
    return null;
  }

  return (
    <div
      className={`row justify-content-center mb-4 ${className}`.trim()}
    >
      <div className="col-12 col-md-10 col-lg-8">
        <div className="gre-banner-shell">
          <img
            src={imageSrc}
            alt={
              propertyTitle
                ? `${propertyTitle} property branding`
                : "Property branding"
            }
            className="gre-banner-shell__image"
          />
        </div>
      </div>
    </div>
  );
};

export default PropertyDeveloperBanner;
